'use strict';

import { recaptchaUpdater } from '../../modules/recaptcha';

export const showLoginForm = () => {
  recaptchaUpdater('login');
};
